import PublishRouter from "@/router/routerMap/PublishRouter";
import SendRouter from "@/router/routerMap/SendRouter";
import { RouteRecordRaw } from "vue-router";

export default [...PublishRouter, ...SendRouter] as Array<RouteRecordRaw>;
